import { createSelector } from 'reselect';

const selectUsers = ({ users }) => users;

const selectListUsers = createSelector(
  selectUsers,
  ({ listUsers }) => listUsers,
);

const selectListUsersData = () =>
  createSelector(selectListUsers, ({ data }) => data);
const selectListUsersLoading = () =>
  createSelector(selectListUsers, ({ isLoading }) => isLoading);
const selectListUsersError = () =>
  createSelector(selectListUsers, ({ error }) => error);

const selectListRoles = createSelector(
  selectUsers,
  ({ listRoles }) => listRoles,
);

const selectListRolesData = () =>
  createSelector(selectListRoles, ({ data }) => data);
const selectListRolesLoading = () =>
  createSelector(selectListRoles, ({ isLoading }) => isLoading);
const selectListRolesError = () =>
  createSelector(selectListRoles, ({ error }) => error);

const selectCreateUser = createSelector(
  selectUsers,
  ({ createUser }) => createUser,
);

const selectCreateUserData = () =>
  createSelector(selectCreateUser, ({ data }) => data);
const selectCreateUserLoading = () =>
  createSelector(selectCreateUser, ({ isLoading }) => isLoading);
const selectCreateUserError = () =>
  createSelector(selectCreateUser, ({ error }) => error);

const selectUpdateMyAccount = createSelector(
  selectUsers,
  ({ updateMyAccount }) => updateMyAccount,
);

const selectUpdateMyAccountData = () =>
  createSelector(selectUpdateMyAccount, ({ data }) => data);
const selectUpdateMyAccountLoading = () =>
  createSelector(selectUpdateMyAccount, ({ isLoading }) => isLoading);
const selectUpdateMyAccountError = () =>
  createSelector(selectUpdateMyAccount, ({ error }) => error);

const selectRemoveUser = createSelector(
  selectUsers,
  ({ removeUser }) => removeUser,
);

const selectRemoveUserData = () =>
  createSelector(selectRemoveUser, ({ data }) => data);
const selectRemoveUserLoading = () =>
  createSelector(selectRemoveUser, ({ isLoading }) => isLoading);
const selectRemoveUserError = () =>
  createSelector(selectRemoveUser, ({ error }) => error);

const selectOidc = ({ oidc }) => oidc;

const selectLoggedUser = () => createSelector(selectOidc, ({ user }) => user);
const selectIsLoggedUserAdmin = () =>
  createSelector(selectOidc, (oidc) => {
    const { user, isLoadingUser } = oidc;

    if (!isLoadingUser && user) {
      if (user.profile.company_id) return false;

      return true;
    }

    return false;
  });
const selectLoggedUserIsLoading = () =>
  createSelector(selectOidc, ({ isLoadingUser }) => isLoadingUser);

export default {
  selectListUsersData,
  selectListUsersLoading,
  selectListUsersError,

  selectListRolesData,
  selectListRolesLoading,
  selectListRolesError,

  selectCreateUserData,
  selectCreateUserLoading,
  selectCreateUserError,

  selectUpdateMyAccountData,
  selectUpdateMyAccountLoading,
  selectUpdateMyAccountError,

  selectRemoveUserData,
  selectRemoveUserLoading,
  selectRemoveUserError,

  selectLoggedUser,
  selectIsLoggedUserAdmin,
  selectLoggedUserIsLoading,
};
